import React from "react";

type condition = {text: string, icon: JSX.Element, value: boolean}
export type FormInput = {
    text: string,
    label: string,
    value: string,
    textArea: boolean,
    fieldIsValid: boolean,
    onChange: (a: any) => any,
    conditions: condition[] }

const ContactFormInput = ({contactFormInput, remarkInvalidAndEmpty}:{contactFormInput:FormInput, remarkInvalidAndEmpty: boolean}) =>{
    const stateClass = contactFormInput.fieldIsValid
        ? "border-green-500/60"
        : remarkInvalidAndEmpty
            ? "border-red-400"
            : "border-borderLight dark:border-borderDark"
    return(
        contactFormInput.textArea ?
                <textarea rows={5} value={contactFormInput.value}
                          className={`w-full max-w-[500px] rounded-lg border bg-surfaceLight dark:bg-bgDark px-3 py-2
                          text-base outline-none transition-colors focus:border-accent focus:ring-2
                          focus:ring-accent/30 resize-none ${stateClass}`}
                          onChange={(e) => contactFormInput.onChange(e.target.value)}
                          name={contactFormInput.label}/>
                : <input value={contactFormInput.value}
                         className={`w-full max-w-72 rounded-lg border bg-surfaceLight dark:bg-bgDark px-3 py-2
                         text-base outline-none transition-colors focus:border-accent focus:ring-2
                         focus:ring-accent/30 ${stateClass}`}
                         onChange={(e) => contactFormInput.onChange(e.target.value)}
                         type="text"
                         name={contactFormInput.label}/>
    )
}

export default ContactFormInput
